import RouterStore from "./RouterStore";
import AdminSiderStore from "./AdminSiderStore";
import SystemInfoStore from "./SystemInfoStore";
import MainPageStore from "./MainPageStore";
import UserInfoStore from "./UserInfoStore";

export const Store =  {
    RouterStore,
    AdminSiderStore,
    SystemInfoStore,
    MainPageStore,
    UserInfoStore,
}